import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/integracao`

    const headers = { responseType: "arraybuffer" }

    return {
        bnafarRelatorioEnvio(params) {
            return repository.post(`${baseUrl}/bnafar-relatorio-envio`, params, headers)
        },
        riaRelatorioEnvio(queryParms) {
            return repository.get(`${baseUrl}/ria-relatorio-envio?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioAtendimento(queryParms) {
            return repository.get(`${baseUrl}/relatorio-atendimento?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}